import { render } from "./PriceEnrollNodeView.vue?vue&type=template&id=8f6320d4&scoped=true"
import script from "./PriceEnrollNodeView.vue?vue&type=script&lang=js"
export * from "./PriceEnrollNodeView.vue?vue&type=script&lang=js"

import "./PriceEnrollNodeView.vue?vue&type=style&index=0&id=8f6320d4&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f6320d4"]])

export default __exports__